import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { AppConfigProvider } from './hooks/use-app-config'
import { AppearanceProvider } from './hooks/use-appearance'
import { TooltipProvider } from './components/ui/tooltip'
import { initializeTheme } from './lib/appearance'
import { router } from './router'
import './styles.css'

initializeTheme()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <AppearanceProvider>
      <AppConfigProvider>
        <TooltipProvider>
          <RouterProvider router={router} />
        </TooltipProvider>
      </AppConfigProvider>
    </AppearanceProvider>
  </StrictMode>,
)
